import React from 'react';
import { VenereButton } from './VenereButton';

export interface VenereDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  primaryButton?: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
  };
  secondaryButton?: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
  };
  showCloseButton?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const VenereDialog: React.FC<VenereDialogProps> = ({
  isOpen,
  onClose,
  title,
  children,
  primaryButton,
  secondaryButton,
  showCloseButton = true,
  size = 'md',
  className = '',
}) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={handleBackdropClick}
      />
      
      {/* Dialog */}
      <div className={`relative bg-white rounded-xl shadow-xl ${sizeClasses[size]} w-full mx-4 ${className}`}>
        {/* Header */}
        {(showCloseButton) && (
          <div className="flex items-center justify-between p-6 pb-4">
            {showCloseButton && (
              <VenereButton variant='close' onClick={onClose}/>
            )}
          </div>
        )}
        
        {/* Content */}
        <div className="p-6">
          {children}
        </div>
        
        {/* Footer */}
        {(primaryButton || secondaryButton) && (
          <div className="flex gap-3 px-6 pb-6">
            {secondaryButton && (
              <VenereButton
                variant="secondary-lavender"
                onClick={secondaryButton.onClick}
                disabled={secondaryButton.disabled}
                className="flex-1"
              >
                {secondaryButton.text}
              </VenereButton>
            )}
            {primaryButton && (
              <VenereButton
                onClick={primaryButton.onClick}
                disabled={primaryButton.disabled}
                loading={primaryButton.loading}
                className="flex-1"
              >
                {primaryButton.text}
              </VenereButton>
            )}
          </div>
        )}
      </div>
    </div>
  );
}; 